import { PanelCallEpisodeStruct } from "../../structs/orchestrator-panel/panel-call-episode.struct";

export class CallPanelRequest{
    public episodeData: PanelCallEpisodeStruct;
    
    public idQueue: number;
    
    public idRoomOrigin: number;
    
    public isVerifyCall: boolean;
    
    public login: string;
    
    public password: string;

    public idModule: number;
}